import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Payment = () => {
    return (
        <>
        <div className="main-content">
                <div className="container-fluid">
                    <div className="header-body">
                        <div className="row align-items-center py-4">
                            <div className="col-lg-12 mt-5">
                                <div className="service--title text-center pt-5">
                                    <h2 className="reg-bod-56">Payment Section is <br /><strong>Coming SOON!</strong></h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Payment;